import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 px-6">
      <h1>{t("pages:dashboard.title")}</h1>
      <p>{t("pages:dashboard.description")}</p>
      Hello "/(protected)/dashboard/"!
    </div>
  );
}
